import { render, staticRenderFns } from "./DevParamList.vue?vue&type=template&id=c39d5d66&scoped=true&"
import script from "./DevParamList.vue?vue&type=script&lang=js&"
export * from "./DevParamList.vue?vue&type=script&lang=js&"
import style0 from "./DevParamList.vue?vue&type=style&index=0&id=c39d5d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39d5d66",
  null
  
)

export default component.exports